/* see docs/EXTRACTED_COMMENTS.md#c074 */

export interface EditorDefaults {
  textColor: string | null
  foregroundClass: string | null
  backgroundColor: string | null
  backgroundClass: string | null
  fontFamily: string | null
  fontClass: string | null
  fontSize: number
  fontStyle: string | null
  fontWeight: string | null
}

export interface ForegroundOption {
  label: string
  className: string
  color: string
}

export interface BackgroundOption {
  label: string
  className: string
  backgroundColor: string
}

export interface FontOption {
  label: string
  className: string
  fontFamily: string
}

export interface EditorDefaultsTuneConfig {
  getDefaults: () => EditorDefaults
  applyDefaults: (defaults: Partial<EditorDefaults>) => void
  getForegroundOptions: () => ForegroundOption[]
  getBackgroundOptions: () => BackgroundOption[]
  getFontOptions: () => FontOption[]
  getSizeOptions: () => number[]
}

export const FONT_SIZE_OPTIONS: number[] = [
  8, 10, 12, 14, 16, 18, 20, 24, 28, 32,
]

export const DEFAULT_FONT_SIZE = 12

export function makeEmptyDefaults(): EditorDefaults {
  return {
    textColor: null,
    foregroundClass: null,
    backgroundColor: null,
    backgroundClass: null,
    fontFamily: null,
    fontClass: null,
    fontSize: DEFAULT_FONT_SIZE,
    fontStyle: null,
    fontWeight: null,
  }
}
